
















import { Component, Vue } from 'vue-property-decorator';
import { Route, RouteConfig } from 'vue-router';

@Component
export default class Breadcrumb extends Vue {
    public get breadcrumbs(): Array<RouteConfig> {
        const routes = this.$route.matched.filter((route) => {
            return route.meta.ignoreBreadcrumb !== true;
        }).map((route) => {
            return { name: route.name, path: route.path, meta: route.meta };
        });

        const home = routes.find((route) => route.name === 'home');

        if (home == null) {
            routes.unshift({ name: 'home', path: '', meta: { title: 'Home' } });
        }

        return routes;
    }
}
